export * from './lociApi.js';
export {
  lociApi,
  useGetEventsQuery,
  useGetTrendingEventsQuery,
  useUpdateUserPreferencesMutation,
  useGetNotificationPreferencesQuery,
  useUpdateNotificationPreferencesMutation,
  useSubscribeWebPushMutation,
  useUnsubscribeWebPushMutation,
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useGetUnreadCountQuery,
  useMarkReadMutation,
  useCompleteOnboardingMutation,
  useGetCurrentUserQuery,
  useListAuthSessionsQuery,
  useLoginMutation,
  useRegisterMutation,
  useLogoutMutation,
  useLogoutAllMutation,
  useDeleteAccountMutation,
  useExportAccountDataMutation,
  useGetBrowsingHistorySummaryQuery,
  useLazyGetBrowsingHistorySummaryQuery,
  useClearBrowsingHistoryMutation,
  useClearStoredLocationMutation,
  useRevokeSessionMutation,
  useRefreshTokenMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useVerifyEmailMutation,
  useResendVerificationMutation,
  useRequestMagicLinkMutation,
  useConsumeMagicLinkMutation,
  useMapChatMutation,
  useChangePasswordMutation,
  useUpdateProfileMutation,
  usePasskeyAuthenticationBeginMutation,
  usePasskeyAuthenticationFinishMutation,
  useGetSearchSuggestionsQuery,
  useGetEventsListQuery,
  useGetCategoriesQuery,
  useUnlinkProviderMutation,
  useUnlinkPasskeyMutation,
  useEnableMagicLinkSignInMutation,
  usePasskeyRegisterBeginMutation,
  usePasskeyRegisterFinishMutation,
  useGetSavedEventsQuery,
  useLazyGetSavedEventsQuery,
  useGetFollowingSavedEventsQuery,
  useGetUserFootprintQuery,
  useGetEventUserStateQuery,
  useSaveEventMutation,
  useUnsaveEventMutation,
  useRsvpEventMutation,
  useUnrsvpEventMutation,
  useGetPlaceDetailsQuery,
  useLazyGetPlaceDetailsQuery,
  useGetEventSocialQuery,
} from './lociApi.js';
export { navigateToProviderLink } from './lociApi.js';
export type {
  EventsListQuery,
  EventsListResponse,
  GetSavedEventsArg,
  GetUserFootprintArg,
  UserFootprintResponse,
  EventUserStateResponse,
  SaveEventArg,
  UnsaveEventArg,
  RsvpEventArg,
  EventRsvpResponse,
  EventSocialResponse,
  EventSocialFriend,
  PlaceCardDetailsV1,
  MapChatResponse,
  MapChatPlaceResult,
  PasskeyRegisterBeginResponse,
  PasskeyRegisterFinishRequest,
  PasskeyRegisterFinishResponse,
  EnableMagicLinkSignInResponse,
  AuthMeCurrentSession,
  UserAccountExport,
  NotificationPreferences,
  WebPushSubscriptionRequest,
  WebPushSubscriptionResponse,
  WebPushUnsubscribeRequest,
  WebPushUnsubscribeResponse,
  NotificationItem,
  NotificationListResponse,
  NotificationUnreadCountResponse,
  MarkNotificationsReadRequest,
  MarkNotificationsReadResponse,
  GetNotificationsArg,
} from './lociApi.js';
export type {
  UserPreferences,
  UserPrivacyPreferences,
  LoginRequest,
  RegisterRequest,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  ResetPasswordRequest,
  ChangePasswordRequest,
  ChangeEmailRequest,
  UpdateProfileRequest,
  UpdateProfileResponse,
  VerifyEmailRequest,
  ResendVerificationRequest,
  ResendVerificationResponse,
  MagicLinkRequest,
  MagicLinkRequestResponse,
  MagicLinkConsumeRequest,
  MagicLinkConsumeResponse,
  User,
  AuthResponse,
  PasskeyAuthenticationBeginResponse,
  PasskeyAuthenticationFinishRequest,
  PasskeyAuthenticationFinishResponse,
  PublicIdentity,
  IdentityType,
} from './types.js';

// Export generated types
export type {
  BackendApiComponents as components,
  BackendApiPaths as paths,
  QueryParams,
  ResponseBody,
  RequestBody,
} from '@loci/types';

// Export backward compatibility utilities
export type { LegacyNearbyEvent } from './compat.js';
export { toLegacyNearbyEvent, toLegacyNearbyEvents } from './compat.js';

// Discover surface view-model re-exports (WEB-46)
export type {
  DiscoverEvent,
  DiscoverBadge,
  DiscoverFacetCounts,
  DiscoverFacetScopeKey,
  DiscoverPriceBucket,
  DiscoverAuthenticatedEnvelope,
  DiscoverFollowedArtist,
  DiscoverFollowedVenue,
  DiscoverPickedForYou,
  DiscoverSavedSearch,
  DiscoverTasteChip,
  DiscoverTasteProfile,
} from './types/discover.js';

// Discover surface RTK Query bindings (WEB-53 · M7.3)
export {
  useDiscoverEventsQuery,
  useDiscoverFacetsQuery,
  // API-1720 — typed access to the injectEndpoints-augmented discover cache
  upsertDiscoverEventsQueryData,
  selectDiscoverEventsQuery,
} from './endpoints/discover.js';
export type {
  DiscoverCalendarTopEvent,
  DiscoverCalendarTopEvents,
  DiscoverEventsQueryArgs,
  DiscoverEventsQuerySelection,
  DiscoverEventsResponse,
  DiscoverFacetsResponse,
  DiscoverMeta,
  DiscoverSortMode,
  DiscoverViewMode,
} from './endpoints/discover.js';

// Discover saved-search RTK Query bindings (FRE-1147; backend FRE-926)
export {
  useListSavedSearchesQuery,
  useLazyListSavedSearchesQuery,
  useCreateSavedSearchMutation,
  useDeleteSavedSearchMutation,
} from './endpoints/savedSearches.js';
export type {
  SavedSearch,
  SavedSearchWithNewCount,
  CreateSavedSearchRequest,
  ListSavedSearchesResponse,
  DeleteSavedSearchResponse,
} from '@loci/types';

// Self-serve advertiser portal (WEB-40 org step; API-1626/1627/1628/1630 —
// venue claims, claim-gated listing create, Stripe Checkout, status inbox read)
export {
  useCreateAdvertiserMutation,
  useListVenueClaimsQuery,
  useLazyListVenueClaimsQuery,
  useCreateVenueClaimMutation,
  useListMySponsoredListingsQuery,
  useLazyListMySponsoredListingsQuery,
  useCreateSponsoredListingMutation,
  useCreateSponsoredCheckoutSessionMutation,
  // WEB-587 — the wizard's venue-search and event-picker reads.
  useListClaimableVenuesQuery,
  useLazyListClaimableVenuesQuery,
  useListSponsorableEventsQuery,
  useLazyListSponsorableEventsQuery,
  // WEB-1263 — public checkout-availability read (API-1847).
  useGetSponsoredCheckoutStatusQuery,
  markSponsoredCheckoutClosed,
  SPONSORED_CHECKOUT_STATUS_TIMEOUT_MS,
} from './endpoints/advertisers.js';
export type {
  AdvertiserPayload,
  VenueClaimPayload,
  SponsoredListingPayload,
  ClaimableVenuePayload,
  ListClaimableVenuesRequest,
  ListClaimableVenuesResponse,
  SponsorableEventPayload,
  ListSponsorableEventsRequest,
  ListSponsorableEventsResponse,
  CreateAdvertiserRequest,
  CreateAdvertiserResponse,
  CreateVenueClaimRequest,
  VenueClaimResponse,
  ListVenueClaimsResponse,
  CreateSponsoredListingRequest,
  SponsoredListingResponse,
  ListSponsoredListingsResponse,
  CreateSponsoredCheckoutSessionRequest,
  SponsoredCheckoutSessionResponse,
  SponsoredCheckoutStatusResponse,
} from './endpoints/advertisers.js';

// Apple Music connect surface RTK Query bindings (WEB-443, WEB-445);
// taste hub + city-charts reads (WEB-449 / API-1506).
export {
  useGetMusicTokenQuery,
  useConnectMusicMutation,
  useGetMusicStatusQuery,
  useDisconnectMusicMutation,
  useGetMusicTasteQuery,
  useGetMusicCityChartsQuery,
} from './endpoints/music.js';
export type {
  MusicTokenResponse,
  MusicConnectRequest,
  MusicConnectResponse,
  MusicStatusResponse,
  MusicTasteResponse,
  MusicCityChartsResponse,
  MusicCityChartsArgs,
} from './endpoints/music.js';

import type { LegacyNearbyEvent } from './compat.js';
import type { BackendApiComponents } from '@loci/types';

// Backward compatibility type aliases
export type EventItem = LegacyNearbyEvent;

export interface EventsQuery {
  lat?: number;
  lon?: number;
  radiusKm?: number;
  category?: string;
}

export type EventsResponse = {
  events?: EventItem[];
  totalCount?: number;
  searchCenter?: BackendApiComponents['schemas']['Coordinates'];
  searchRadius?: number;
  searchType?: 'radius' | 'bbox';
};
